import { HttpService } from "./http.service";

const basePath = "/PredictionModelConfig";
const request = HttpService.handleRequest();

export const PredictionModelConfigService = {
  getByPredictionModel,
  UpdatePredictionModel,
  getByPredictionModelOnlyConfigs,
  getAll
};

async function getByPredictionModel(id) {
  return request.get(`${basePath}/GetByPredictionModelId/${id}`);
}

async function getByPredictionModelOnlyConfigs(id) {
  return request.get(`${basePath}/GetByPredictionModelId/onlyConfigs/${id}`);
}

async function UpdatePredictionModel(data) {
  return request.put(`${basePath}/UpdatePredictionModel/`, data);
}

async function getAll() {
  return request.get(basePath);
}

export default PredictionModelConfigService;